module.exports = __webpack_public_path__ + "static/media/merton.cb1803d9.jpg";